import { z } from 'zod'

/**
 * Werkaccount activeren (backoffice, medewerkersprofiel): zet het echte
 * @streep.nl-adres als werk-mail en stuurt optioneel de welkomstmail.
 *
 * batch-61 welkomstmail (FO-448): de welkomstmail is de "Welkomstmail + inlog
 * delen"-mail (portal-URL + Microsoft Entra-inloguitleg, welkomsbrief als
 * bijlage). Er gaat NOOIT een wachtwoord in een mail (spec 148 §4); het
 * vroegere `wachtwoord`-veld is daarom vervallen.
 */
export const ActiveerWerkaccountSchema = z.object({
  workEmail: z
    .string()
    .email()
    .refine((v) => v.toLowerCase().endsWith('@streep.nl'), {
      message: 'Werk-e-mail moet eindigen op @streep.nl',
    }),
  stuurWelkomstmail: z.boolean(),
})

export type ActiveerWerkaccountInput = z.infer<typeof ActiveerWerkaccountSchema>
